import { render, staticRenderFns } from "./costServingUsersModal.vue?vue&type=template&id=56a23b1e&"
import script from "./costServingUsersModal.vue?vue&type=script&lang=js&"
export * from "./costServingUsersModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports